import { render, staticRenderFns } from "./aro.vue?vue&type=template&id=71c37c4b&"
import script from "./aro.vue?vue&type=script&lang=ts&"
export * from "./aro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports